import { render, staticRenderFns } from "./FtpSettings.vue?vue&type=template&id=024e1f7f"
import script from "./FtpSettings.vue?vue&type=script&lang=ts"
export * from "./FtpSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports